import { StockLocation } from "../types/stock_location";

export const newStockLocation = (): StockLocation => {
  return {
    name: '',
    active: 1,
    camposPersonalizados: [],
  }
}